import {useEffect, useRef, useState} from "react";

export default function useScrollableWithFade(numberOfItemsDisplayed) {
    const containerRef = useRef(null)
    const [isFaded, setIsFaded] = useState(false)

    useEffect(() => {
        const childHeight = containerRef.current.children[0]?.clientHeight

        if (childHeight) {
            containerRef.current.style.height = `${numberOfItemsDisplayed * childHeight}px`;
        }
    }, []);

    useEffect(() => {
        const container = containerRef.current
        const checkVisibility = () => {
            if (containerRef?.current.children.length) {
                const lastChildRect = containerRef.current.children[containerRef.current.children.length - 1].getBoundingClientRect()
                const containerRect = containerRef.current.getBoundingClientRect()

                if (lastChildRect.bottom > containerRect.bottom) {
                    setIsFaded(true)
                } else {
                    setIsFaded(false)
                }
            }
        }
        checkVisibility()

        container.addEventListener('scroll', checkVisibility);

        return () => {
            container.removeEventListener('scroll', checkVisibility);
        };
    }, [])

    const fadeClass = isFaded ? "gb--review-faded gb--review-faded-bottom" : ""

    return {
        containerRef,
        fadeClass,
    }
}